<script setup>

</script>

<template>
  <section>
    <div class="opening">
      <RouterLink
        class="c-button c-button--medium c-button--black"
        :to="{name:'Login'}"
      >
        ログイン画面に遷移
      </RouterLink>

      <RouterLink
        class="c-button c-button--medium c-button--black"
        :to="{name:'RegisterInput'}"
      >
        新規登録画面に遷移
      </RouterLink>
    </div>
  </section>
</template>

<style scoped lang="scss">
.opening{
  padding-top: 200px;
  margin: 0 auto;
  width: 600px;
}
</style>
